import React from 'react';
import './ThankYouPage.css';
import { useTranslation } from "react-i18next";
const ThankYouPage = () => {
  const { t } = useTranslation();

  return(
    <div className="thank-you-container">
    <div className="thank-you-card">
      <h1 className="thank-you-title">{t("thankYouTitle")}</h1>
      <p className="thank-you-message">{t("thankYouMessage")}</p>
      <button className="back-home-btn" style={{ background: 'var(--ocean-teal)', color:'white'}}  onClick={() => window.location.href = '/'}>
        {t("backHome")}
      </button>
    </div>
  </div>
  )
  
}


export default ThankYouPage;
